const ENTITY_TYPE = {
  SALARY_TYPES: 'SALARY_TYPES',
  ABSENCE_REASON_TYPES: 'ABSENCE_REASON_TYPES',
  ABSENCE_TYPES: 'ABSENCE_TYPES',
  TIME_TRACKERS: 'TIME_TRACKERS',
  BANK_HOLIDAYS: 'BANK_HOLIDAYS',
  OVERTIME_METHODS: 'OVERTIME_METHODS',
  AGREEMENT_TEMPLATES: 'AGREEMENT_TEMPLATES',
} as const;

type TEntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];

// The translation key that names each type: in the copy dialog, and in a copy's progress lines.
const ENTITY_TYPE_LABEL: Record<TEntityType, string> = {
  [ENTITY_TYPE.SALARY_TYPES]: 'copyTenant.salaryTypes',
  [ENTITY_TYPE.ABSENCE_REASON_TYPES]: 'copyTenant.absenceReasonTypes',
  [ENTITY_TYPE.ABSENCE_TYPES]: 'copyTenant.absenceTypes',
  [ENTITY_TYPE.TIME_TRACKERS]: 'copyTenant.timeTrackers',
  [ENTITY_TYPE.BANK_HOLIDAYS]: 'copyTenant.bankHolidays',
  [ENTITY_TYPE.OVERTIME_METHODS]: 'copyTenant.overtimeMethods',
  [ENTITY_TYPE.AGREEMENT_TEMPLATES]: 'copyTenant.agreementTemplates',
};

const DEPENDENCIES: Record<TEntityType, readonly TEntityType[]> = {
  [ENTITY_TYPE.SALARY_TYPES]: [],
  [ENTITY_TYPE.ABSENCE_REASON_TYPES]: [],
  [ENTITY_TYPE.TIME_TRACKERS]: [],
  [ENTITY_TYPE.BANK_HOLIDAYS]: [],
  [ENTITY_TYPE.OVERTIME_METHODS]: [],
  [ENTITY_TYPE.ABSENCE_TYPES]: [
    ENTITY_TYPE.ABSENCE_REASON_TYPES,
    ENTITY_TYPE.SALARY_TYPES,
  ],
  [ENTITY_TYPE.AGREEMENT_TEMPLATES]: [
    ENTITY_TYPE.SALARY_TYPES,
    ENTITY_TYPE.ABSENCE_TYPES,
    ENTITY_TYPE.TIME_TRACKERS,
    ENTITY_TYPE.BANK_HOLIDAYS,
    ENTITY_TYPE.OVERTIME_METHODS,
  ],
};

const getAllRequired = (selected: readonly TEntityType[]) => {
  const required = new Set<TEntityType>(selected);
  const queue = [...selected];

  while (queue.length > 0) {
    const current = queue.pop()!;
    DEPENDENCIES[current].forEach((dep) => {
      if (!required.has(dep)) {
        required.add(dep);
        queue.push(dep);
      }
    });
  }

  return Array.from(required);
};

export { ENTITY_TYPE, ENTITY_TYPE_LABEL, DEPENDENCIES, getAllRequired };
export type { TEntityType };
